import {
  longSortArrowIconPath,
  longSortArrowIconViewBox,
} from './LongArrowDownIcon.tsx'
import { createIcon } from './createIcon'

export const LongArrowUpIcon = createIcon({
  displayName: 'LongArrowUpIcon',
  viewBox: longSortArrowIconViewBox,
  path: [
    <path
      d={longSortArrowIconPath}
      fill="currentColor"
      transform="matrix(1,0,0,-1,0,17)"
    />,
  ],
})
